import {EventEmitter, Injectable} from '@angular/core';
 
@Injectable({
  providedIn: 'root'
})
export class NgChatVolumeService {
  eventEmitter = new EventEmitter<string>();
  constructor() { }
}